import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostBinding, Input,
  OnDestroy, OnInit, Output, ViewEncapsulation
} from '@angular/core';

import { Subscription } from 'rxjs';

import { DeviceService, ICardStore, IPosition, PositionEnum, ThemesEnum } from '@seb/web-design-system/core';
import { IMapLegend } from '@seb/web-design-system/maps';

import { SdStoreLocatorComponent } from '../store-locator/store-locator.component';

@Component({
  selector: 'sd-pickup-location',
  templateUrl: './pickup-location.component.html',
  styleUrls: ['./pickup-location.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdStoreLocatorComponent]
})
export class SdPickupLocationComponent implements OnInit, OnDestroy {
  constructor(
    private deviceService: DeviceService,
    private cdRef: ChangeDetectorRef,
  ) {}

  positionEnum = PositionEnum;
  themesEnum = ThemesEnum;
  selectedStoreData: ICardStore;
  isMobile$: boolean;
  mobileSubscription: Subscription;

  @Input()
  isLoading = false;

  @HostBinding('class.is-embedded')
  @Input()
  isEmbedded = false;

  @Input()
  pickupTitle = 'pickup.title';

  @Input()
  mapSelectAction = 'pickup.actions.choose';

  @Input()
  title: string;

  @Input()
  deliveryAddress: any;

  @Input()
  searchCountryRestrictions: string | string[];

  @Input()
  titleLevel = 4;

  @Input()
  repairCenter = false;

  @Input()
  hideCardActions = false;

  @Input()
  isHob = false;

  @Input()
  stores: ICardStore[] = [];

  @Input()
  mapLegend: IMapLegend[];

  @Input()
  bounds: google.maps.LatLngBoundsLiteral;

  @Input()
  centerOnCountry: { name: string; isocode: string };

  @Input()
  isUserPickupInfoFormValid: boolean;

  @Input()
  searchWord: string;

  @Input()
  selectedPickupId: string;

  @Output()
  selectedStore = new EventEmitter<ICardStore>();

  @Output()
  locate = new EventEmitter<{ location: { coords: IPosition }; address?: any }>();

  ngOnInit() {
    this.mobileSubscription = this.deviceService.isMobile.subscribe((x) => {
      this.isMobile$ = x;
      this.cdRef.markForCheck();
    });
  }

  ngOnDestroy() {
    this.mobileSubscription?.unsubscribe();
  }

  onSelectedStore(store: ICardStore) {
    this.selectedStoreData = store;
    this.selectedStore.emit(store);
  }

  /**
   * Dispatch event with location wanted to get stores
   */
  emitLocateEvent({ location, address }: { location: { coords: IPosition }; address?: any }) {
    this.isLoading = true;
    this.locate.emit({ location, address });
  }
}
